import { useAuth } from '@frontegg/react';
import { useMemo } from 'react';

import runtimeEnv from './runtimeEnv';

const baseUrl = runtimeEnv.apiBaseUrl.replace(/\/$/, '');

console.log(baseUrl);

export function useXFetch() {
  const { user } = useAuth();

  type FetchParams = Parameters<typeof fetch>;

  const xfetch = useMemo(
    () =>
      async function <T = unknown>(input: FetchParams[0], init?: FetchParams[1]): Promise<T> {
        const xinit: FetchParams[1] = {
          ...init,
          mode: 'cors',
          headers: {
            ...init?.headers,
            Authorization: `Bearer ${user?.accessToken}`,
          },
        };
        const uri =
          typeof input === 'string' &&
          !input.startsWith('http:') &&
          !input.startsWith(runtimeEnv.fronteggBaseUrl)
            ? `${baseUrl}/${input.replace(/^\//, '')}`
            : input;

        // console.log({ uri, xinit });
        const res = await fetch(uri, xinit);
        if (res.status !== 200) {
          let data;
          try {
            data = await res.json();
          } catch {
            console.log('error parsing json', data);
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const error: any = new Error(data?.message || res.statusText);
          error.response = { data, status: res.status };
          throw error;
        }
        return res.json() as T;
      },
    [user?.accessToken]
  );
  return xfetch;
}
